import { SuccessPage } from "@/components/pages/SuccessPage";
import { useProfileCopy } from "@/features/i18n/profileCopy";
import { useAuth } from "@/utils/auth";
import { createFileRoute } from "@tanstack/react-router";
import { HeartPulse } from "lucide-react";

const Welcome = () => {
    const { roles } = useAuth();
    const copy = useProfileCopy();

    // Determine which content to use based on role
    const description = roles.isSecretary
        ? copy.welcomeSecretaryDescription
        : roles.isClinician
          ? copy.welcomeClinicianDescription
          : roles.isManager
            ? copy.welcomeManagerDescription
            : copy.welcomePatientDescription;

    return (
        <SuccessPage
            title={copy.welcomeTitle}
            description={description}
            icon={HeartPulse}
            loadingText={copy.settingUpAccount}
            loadingDescription={copy.gettingAccountReady}
            primaryButton={{
                text: copy.continueToProfileSetup,
                to: roles.isClinician ? "/onboarding/clinician/name" : "/onboarding/name",
            }}
        />
    );
};

export const Route = createFileRoute("/onboarding/welcome")({
    component: Welcome,
});
